import React from "react"
import { useSearchParams } from "react-router-dom"
import AgentViewFeedbackContainer from "./AgentViewFeedbackContainer";

export default function FirestoneCallFinderTabContainer() {
    const [searchParams] = useSearchParams();
    const callRefId = searchParams.get('callRefId');
    const customerId = searchParams.get('customerId');
    const date = searchParams.get('date');

    return (
        <AgentViewFeedbackContainer callRefId={callRefId ?? undefined} customerId={customerId ?? undefined} date={date ?? undefined} />
    )
}
